import React from 'react';
import { toast } from 'react-toastify';
import { ReactComponent as IconInfo } from '../../assets/icons/svg/colored-icons/ic-colored-info.svg';
import { ReactComponent as StopperIcon } from '../../assets/icons/svg/shared/ic-shared-stopper.svg';
import { ReactComponent as IconVMark } from '../../assets/icons/svg/shared/ic-shared-checkmark-circle.svg';
import { ReactComponent as ErrorIcon } from '../../assets/icons/svg/shared/ic-shared-error-triangle.svg';
import { CloseButton } from '../LiliCloseButton/CloseButton';

export enum LiliNotificationType {
  INFORMATIONAL,
  WARNING,
  SUCCESS,
  ERROR,
}

export interface LiliNotificationProps {
  title?: string;
  text: string;
  id: string;
  type?: LiliNotificationType;
  undismissable?: boolean;
}

const LiliNotification = (props: LiliNotificationProps) => {
  const { title, text, id, type = LiliNotificationType.INFORMATIONAL, undismissable = false } = props;

  const getClassNameByType = () => {
    switch (type) {
      case LiliNotificationType.INFORMATIONAL:
        return 'border-action04';
      case LiliNotificationType.WARNING:
        return 'border-badgeAmber02';
      case LiliNotificationType.SUCCESS:
        return 'border-badgeGreen02';
      case LiliNotificationType.ERROR:
        return 'border-red02';
      default:
        return '';
    }
  };

  const getIconByType = () => {
    switch (type) {
      case LiliNotificationType.INFORMATIONAL:
        return <IconInfo />;
      case LiliNotificationType.WARNING:
        return <StopperIcon className='text-badgeAmber02' />;
      case LiliNotificationType.SUCCESS:
        return <IconVMark className='text-badgeGreen02' />;
      case LiliNotificationType.ERROR:
        return <ErrorIcon className='text-red02' />;
      default:
        return '';
    }
  };

  return (
    <div
      id={`${id}`}
      data-testid='toastMessage'
      className={`w-[467px] flex justify-between flex-row gap-[8px] items-center border-[1px] rounded-lg px-[12px] py-[10px] ${getClassNameByType()}`}
    >
      <div className='flex flex-row gap-[8px] items-center'>
        <div>{getIconByType()}</div>
        <div className='flex flex-col'>
          {title && (
            <div className='flex flex-grow-1 text-[13px] leading-[18px] font-metricRSemibold text-bw08'>{title}</div>
          )}

          <div className='flex flex-grow-1 text-[13px] leading-[18px] font-metricR text-bw08'>{text}</div>
        </div>
      </div>
      {undismissable === false && <CloseButton id='close-notification' onClick={() => toast.dismiss()} />}
    </div>
  );
};

export default LiliNotification;
